<template>
  <div>
    <div class="social-auth-buttons text-center">
      <div class="mb-3">{{ $t('forms.login_form.social_login_title') }}</div>
      <ul class="list-inline mb-3">
        <li class="list-inline-item"><a href="#" @click.prevent="logInWithFacebook">
          <img :src="require('@/assets/social_auth/icon-facebook.svg')" alt="Facebook Account">
        </a></li>
        <li class="list-inline-item">
          <a href="#" @click.prevent="logInWithGoogle">
            <img :src="require('@/assets/social_auth/icon-google.svg')" alt="Google Account">
          </a>
        </li>
        <li class="list-inline-item"><a href="#" @click.prevent="logInWithApple" v-if="!appleDisabled">
          <img :src="require('@/assets/social_auth/icon-apple.svg')" alt="Apple Account">
        </a></li>
      </ul>
      <span class="social-auth-buttons--error-message" v-if="authError">
        {{ $t('forms.login_form.social_login_error') }}
      </span>
    </div>
  </div>
</template>

<script>


import {loadInitFacebookSDK} from "@/utils/social_oauth/facebook";
import {loadInitAppleSDK} from "@/utils/social_oauth/apple";
import {loadInitGoogleSDK, loginGoogleUser} from "@/utils/social_oauth/google";
import {mapActions, mapGetters} from "vuex";


export default {
  name: 'SocialLogin',

  data() {
    return {
      authError: false
    }
  },
  computed: {
    ...mapGetters({
      appleDisabled: "disableSocialLoginInPreview"
    }),
    ...mapGetters('auth', ['hasAcceptedRequiredPolicies']),
  },
  async mounted() {
    const promises = [loadInitFacebookSDK(), loadInitGoogleSDK()];
    if (!this.appleDisabled) {
      promises.push(loadInitAppleSDK());
    }
    await Promise.all(promises);
  },
  methods: {
    ...mapActions('auth', [
      'getCurrentUser',
    ]),
    async logInWithGoogle() {
      await loginGoogleUser().then((response) => {
        const data = {
          client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
          grant_type: "convert_token",
          backend: "google-oauth2",
          token: response.access_token,
          language: this.$i18n.locale
        }

        this.$store.dispatch("auth/socialLogin", data).then(async () => {
          await this.completeLogin()
        }).catch(error => {
          this.authError = true
          console.log('Google login error', error.response.data)
        })
      })
    },

    async logInWithApple() {
      this.authError = false
      try {
        const authResponse = await window.AppleID.auth.signIn()
        if (authResponse && authResponse.authorization) {
          const data = {
            client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
            grant_type: "convert_token",
            backend: "apple-id",
            token: authResponse.authorization.id_token,
            language: this.$i18n.locale
          }
          this.$store.dispatch("auth/socialLogin", data).then(async () => {
            await this.completeLogin()
          }).catch(error => {
            console.log('Apple: login error', error.response.data)
          })
        } else {
          this.authError = true
        }
      } catch (error) {
        console.log('Apple Id error', error)
      }
    },


    logInWithFacebook() {
      const params = {scope: 'email'}
      this.authError = false

      window.FB.login(response => {
        if (response && response.authResponse) {
          const data = {
            client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
            grant_type: "convert_token",
            backend: "facebook",
            token: response.authResponse.accessToken,
            language: this.$i18n.locale
          }

          window.FB.api(`/${response.authResponse.userID}?fields=email`, userResponse => {
            if (userResponse && userResponse.email) {
              console.log('FB user --> ', userResponse);
              this.$store.dispatch("auth/socialLogin", data).then(async () => {
                await this.completeLogin()
              }).catch(err => {
                console.log('Facebook login error', err.response.data)
              })
            } else {
              this.authError = true
              // revoke app permissions
              window.FB.api(`/${response.authResponse.userID}/permissions/`, 'delete', response => {
                console.log(response);
              });
            }
          }, params);

        }
      }, params)

      return false;
    },

    async completeLogin() {
      await this.getCurrentUser()
      // Check if the user has accepted required policies
      if (!this.hasAcceptedRequiredPolicies) {
        await this.$router.push({name: 'terms', params: {next: 'checkins-list'}})
      } else {
        await this.$router.push({name: 'checkins-list'})
      }
    }
  }
}
</script>
